import { isSameWeek } from 'date-fns';
import get from 'lodash.get';
import { selectTimeshetsGroupedByGroupId } from 'services/timesheets/selectors';
import { Timesheet } from 'services/timesheets/types';
import { AppState } from 'services/types';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

import { Props } from './index';

const selectGroupId = (state: AppState, props: Props) => props.groupId;
const selectStartDate = (state: AppState, props: Props) => props.startDate;

const selectGroupTimesheetAlreadyExistLength = createDeepEqualSelector(
    selectGroupId,
    selectStartDate,
    selectTimeshetsGroupedByGroupId,
    (groupId, startDate, timesheetsGroupedByGroupId) => {
        if (!groupId || !startDate) {
            return 0;
        }

        const weekDate = new Date(startDate);

        if (timesheetsGroupedByGroupId) {
            const groupTimesheets = get(
                timesheetsGroupedByGroupId,
                groupId,
                []
            );

            return groupTimesheets.filter(
                (timesheet: Timesheet) =>
                    !timesheet.lastExportedAt &&
                    !timesheet.deletedAt &&
                    isSameWeek(new Date(timesheet.startDate), weekDate)
            ).length;
        }

        return 0;
    }
);

const makeSelectGroupTimesheetAlreadyExistLength = (): typeof selectGroupTimesheetAlreadyExistLength =>
    selectGroupTimesheetAlreadyExistLength;

const selectGroupTimesheetAlreadyExist = createDeepEqualSelector(
    selectGroupTimesheetAlreadyExistLength,
    (timesheetAlreadyExistLength) => timesheetAlreadyExistLength > 0
);

const makeSelectGroupTimesheetAlreadyExist = (): typeof selectGroupTimesheetAlreadyExist =>
    selectGroupTimesheetAlreadyExist;

export {
    selectGroupId,
    selectStartDate,
    makeSelectGroupTimesheetAlreadyExistLength,
    makeSelectGroupTimesheetAlreadyExist
};
